import { z } from 'zod';

export const WorkspaceEventStreamPathParamsSchema = z.object({ workspaceId: z.uuid() });

/**
 * The wire frame every workspace event stream connection carries (ADR 0036).
 * Deliberately free of routing ids: `workspaceId` is already known from the URL,
 * while `organizationId` / `memberId` are the server's routing decision — telling
 * a client which Standort an event was routed on would leak structure it may not
 * be entitled to, and it has no use for it.
 */
export const StreamEventSchema = z.object({
  name: z.string(),
  payload: z.unknown(),
});
export type StreamEvent = z.infer<typeof StreamEventSchema>;
